import { ACTIVE_AUDIO_NODE_STORE } from '../globals';
export const isActiveAudioNode = (audioNode) => ACTIVE_AUDIO_NODE_STORE.has(audioNode);
//# sourceMappingURL=is-active-audio-node.js.map